import { Grid } from '@mui/material'
import React from 'react'
import AboutSection from './AboutSection'
import CustomerFeedback from './CustomerFeedback'
import CompanyOverview from './CompanyOverview'

export default function About() {
  return (
   <Grid>
    <CompanyOverview/>
    <AboutSection/>
    <CustomerFeedback/>
   </Grid>
  )
}
